import { useMemo } from "react";
import { Footer } from "risa-oasis-ui_v2";
import { OrganizationType } from "../../../enums/organizationTypes";

interface QuestionnaireFooterProps {
  orgId: string;
  submitting: boolean;
  isQuestionnaireValid: boolean;
  progress: number;
  onCancel: () => void;
  onSubmit: () => void;
}

const QuestionnaireFooter = ({
  orgId,
  submitting,
  isQuestionnaireValid,
  progress,
  onCancel,
  onSubmit,
}: QuestionnaireFooterProps) => {
  const isAstera = orgId === OrganizationType.ASTERA;

  const submitButtonText = useMemo(() => {
    if (isAstera) {
      return "Submit Key";
    } else if (progress && progress > 0) {
      return `Uploading... ${progress.toFixed(0)}%`;
    } else if (submitting) {
      return "Submitting...";
    } else {
      return "Submit Case";
    }
  }, [isAstera, submitting, progress]);

  const isUploading = progress && progress > 0;
  const isSubmitDisabled = !isQuestionnaireValid || isUploading || submitting;

  return (
    <div className="pharma-questionaire-form__footer bg-red-50">
      <Footer
        cancelButtonText="Go Back"
        submitButtonText={submitButtonText}
        onCancelClick={onCancel}
        onSubmitClick={onSubmit}
        isDisabled={isSubmitDisabled}
      />
    </div>
  );
};

export default QuestionnaireFooter;
